"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { cn } from "@aio/platform-ui";

interface ShowcaseNavProps {
  sections: ReadonlyArray<{ href: string; label: string }>;
}

export function ShowcaseNav({ sections }: ShowcaseNavProps) {
  const pathname = usePathname() ?? "";
  return (
    <aside className="md:sticky md:top-6 md:self-start">
      <Link
        href="/showcase"
        className="text-lg font-semibold tracking-tight text-fg transition-colors duration-fast ease-standard hover:text-accent-strong"
      >
        AIO Showcase
      </Link>
      <nav
        aria-label="Showcase sections"
        className="mt-4 flex gap-1 overflow-x-auto text-sm md:mt-6 md:flex-col md:overflow-visible"
      >
        {sections.map((s) => {
          const active = pathname === s.href || pathname.startsWith(s.href + "/");
          return (
            <Link
              key={s.href}
              href={s.href}
              aria-current={active ? "page" : undefined}
              className={cn(
                "shrink-0 rounded-md px-2 py-1.5 transition-colors duration-fast ease-standard",
                active
                  ? "bg-accent/10 font-medium text-accent-strong"
                  : "text-fg hover:bg-muted",
              )}
            >
              {s.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
